// BUILD-046 task 8.11 / 8.18 / 8.20: whether this page runs against the LOCAL PILOT (local mock auth).
//
// The expression is the same one AuthContext.tsx uses for LOCAL_MOCK_AUTH (that constant is not exported, so it is repeated here, in one
// place for the shared-tasks code): `import.meta.env.DEV` is statically false in any `vite build`, so a shipped bundle never shows the
// pilot caller control or the simulated source routes; the explicit opt-in variable keeps ordinary local development against the real
// identity provider from showing them either.
export const LOCAL_PILOT: boolean = import.meta.env.DEV === true && import.meta.env.VITE_LOCAL_MOCK_AUTH === 'true';
